// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import eh_slideSetBtn_click from "../eventHandlers/eh_slideSetBtn_click.js";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const loggerMsgs = {
  initStart: ["init. slideSetBtns"],
  initSuccess: ["init. slideSetBtns", "init. success"],
  noValidDOMEl: ["init. slideSetBtns", "no valid DOM element provided"],
};

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_slideSetBtns() {
  // Setup...
  const { slideSetBtns } = this.ref;
  this.logger("init", loggerMsgs.initStart, "action");

  // Guard...

  if (slideSetBtns === undefined || slideSetBtns?.every((el) => !this.validate_refEl(el)))
    return this.cancel_featInit(loggerMsgs.noValidDOMEl);

  // Listen to click events on slide-set-btns...
  slideSetBtns.forEach((el) => el.addEventListener("click", eh_slideSetBtn_click.bind(this, el)));

  // Conclude...
  this.logger("init", loggerMsgs.initSuccess, "success", { inline: true });
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
